import React from "react";
import { Route, Routes } from "react-router-dom";
import Tabs from "../global/PageTabs";
import { Clock } from "react-feather";
import JobListScreen from "./JobListScreen";

const tabs = [
  { key: "job", label: "All Jobs" },
  { key: "error", label: "Errors" },
  { key: "warning", label: "Warnings" },
  { key: "dlq", label: "Unprocessed Webhooks" },
];

const JobRouter = () => {
  return (
    <div>
      <Tabs tabs={tabs} icon={Clock} link />
      <Routes>
        <Route path="job/*" element={<JobListScreen title="All Jobs" />} />
        <Route
          path="error/*"
          element={<JobListScreen title="Errors" error />}
        />
        <Route
          path="warning/*"
          element={<JobListScreen title="Warnings" warning />}
        />
        <Route
          path="dlq/*"
          element={<JobListScreen title="Unprocessed Webhooks" dlq />}
        />
      </Routes>
    </div>
  );
};

export default JobRouter;
